import { render, staticRenderFns } from "./VwRxMapper.vue?vue&type=template&id=4e51952d&scoped=true&lang=pug&"
import script from "./VwRxMapper.vue?vue&type=script&lang=ts&"
export * from "./VwRxMapper.vue?vue&type=script&lang=ts&"
import style0 from "./VwRxMapper.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./VwRxMapper.vue?vue&type=style&index=1&id=4e51952d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e51952d",
  null
  
)

component.options.__file = "VwRxMapper.vue"
export default component.exports